import generate from './generate'
import receive from './receive'

export default {
    generate,
    receive
}



// WEBPACK FOOTER //
// ./src/api/cert/index.js